/* eslint-disable import/prefer-default-export */
import { eventActions } from 'store/slices/eventSlice';
import { createAuditEventApi, getEventsApi, listAuditEventsApi } from 'api/events';
import { debounce } from 'lodash';
import {
  AuditActorRole,
  AuditEventCode,
  AuditEventDescription,
  AuditEventStatus,
} from 'common/constants/auditEvents';
import { handleError } from './errorHandlerThunks';

export const getEvents =
  ({ page }) =>
  (dispatch, getState) => {
    const { sortBy, filter } = getState().criticalEvents.events;

    return getEventsApi({ sortBy, filter, page })
      .then(({ events: { count, results }, eventTypes }) => {
        dispatch(eventActions.loadEvents({ count, events: results, page }));
        dispatch(eventActions.loadEventTypes(eventTypes));
      })
      .catch((error) => dispatch(handleError({ error })));
  };

export const listEventsByPage =
  ({ page }) =>
  (dispatch, getState) => {
    const { filter, sortBy } = getState().criticalEvents.events;

    dispatch(eventActions.updateEventsCurrentPage({ page }));

    return listAuditEventsApi({ filter, page, sortBy })
      .then(({ count, results }) => {
        dispatch(eventActions.loadEvents({ count, events: results, page }));
      })
      .catch((error) => dispatch(handleError({ error })));
  };

export const debouncedGetEvents = debounce(({ dispatch }) => {
  return dispatch(listEventsByPage({ page: 1 })).finally(() =>
    dispatch(eventActions.setEventLoading(false))
  );
}, 1000);

export const sortEvents =
  ({ sortBy }) =>
  (dispatch) => {
    dispatch(eventActions.updateSortBy({ sortBy }));

    debouncedGetEvents({ dispatch });
  };

export const filterEvents =
  ({ filter }) =>
  (dispatch) => {
    dispatch(eventActions.setEventLoading(true));
    dispatch(eventActions.updateFilter({ filter }));

    debouncedGetEvents({ dispatch });
  };

export const recordShippingAuditEventThunk = (params) => () => {
  const {
    eventType,
    pomUserId,
    performedByName,
    shipmentRequestId,
    referenceId,
    correlationId,
    status = AuditEventStatus.SUCCESS,
    metadata = {},
  } = params;

  if (!AuditEventCode[eventType]) return;

  createAuditEventApi({
    auditEventType: eventType,
    auditEventCode: AuditEventCode[eventType],
    description: AuditEventDescription[eventType],
    actorRole: AuditActorRole.POM_USER,
    pomUserId,
    auditSource: 'PRX_SHIPMENT',
    auditEventData: {
      eventType,
      ...(referenceId && { referenceId }),
      ...(shipmentRequestId && { shipmentRequestId }),
      ...(correlationId && { correlationId }),
      status,
      performedBy: pomUserId,
      ...(performedByName && { performedByName }),
      timestamp: new Date().toISOString(),
      metadata,
    },
  });
};
